import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2f612620"
import script from "../src/js/app.js?vue&type=script&lang=js&external"
export * from "../src/js/app.js?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=2f612620&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports